module.exports = __webpack_public_path__ + "static/media/CSL__LoaderIcon.5f3d8b8f.svg";